import styled from 'styled-components';

export const Button = styled.button`
    border-radius: 7px;
    background: #DF6B78;
    height: 25px;
    position: relative;
    margin-top: 5%;
    margin-left: 1%;

    `;

export const Div = styled.div`
    display: flex;
    flex-direction: row;
    right: 5%;
    position: absolute;
    `;

export const Label = styled.label`
    color: #000000;
    white-space: nowrap;
    text-align: left;
    right: 5%;
    margin-top: 7.5%;
    position: relative;
    `;